<template>
  <el-row>
    <el-col :span="24">
      <div class="grid-content padding-top padding-bottom">
        <div class="block padding-all">
          <slot name="filters"></slot>
          <el-row class="margin-md-top" :gutter="10">
            <el-col :span="6">
              <div v-if="typeof dataPaginations[tableName] !== 'undefined'">
                <el-pagination layout="prev, pager, next" :current-page="dataPaginations[tableName].current_page"
                  :page-size="dataPaginations[tableName].per_page" :total="dataPaginations[tableName].total"
                  @current-change="pageChange">
                </el-pagination>
              </div>
              <div v-else>&nbsp;</div>
            </el-col>
            <el-col :span="10">
              <slot name="inline-filters">&nbsp;</slot>
            </el-col>
            <el-col :span="1" v-popover:sortPopup class="text-right">
              <el-tooltip placement="top" :content="`Xắp xếp: ${sortStatus}`" class="display-inline">
                <a href="#" @click.prevent="" class="text-violet">
                  <span class="fa-stack">
                    <i class="fa fa-square-o fa-stack-2x"></i>
                    <i class="fa fa-sort fa-stack-1x"></i>
                  </span>
                </a>
              </el-tooltip>
              <el-popover ref="sortPopup" placement="bottom" width="500" trigger="click">
                <div class="sort-popup">
                  <el-table :data="dataSorts" style="width: 100%" :show-header="false" :border="false">
                    <el-table-column>
                      <template slot-scope="scope">
                        {{ scope.row.name }}
                      </template>
                    </el-table-column>
                    <el-table-column width="250">
                      <template slot-scope="scope">
                        <el-radio-group v-model="dataSorted[scope.row.key]" @change="fetchData">
                          <el-radio label=""><span class="text-black">Không</span></el-radio>
                          <el-radio :label="1"><span class="text-blue">Tăng</span></el-radio>
                          <el-radio :label="-1"><span class="text-red">Giảm</span></el-radio>
                        </el-radio-group>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-popover>
            </el-col>
            <el-col :span="6">
              <el-input size="small" :placeholder="searchText" icon="search" v-model="q" @change="filter">
              </el-input>
            </el-col>
            <el-col :span="1">
              <el-tooltip placement="top" content="Xóa bộ lọc" class="display-inline">
                <a href="#" @click.prevent="removeFilter" class="text-brown">
                  <span class="fa-stack">
                    <i class="fa fa-ban fa-stack-2x"></i>
                    <i class="fa fa-filter fa-stack-1x"></i>
                  </span>
                </a>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
        <slot :data="dataTable"></slot>
        <div class="block pull-right margin-top" v-if="typeof dataPaginations[tableName] !== 'undefined'">
          <el-pagination layout="prev, pager, next" :current-page="dataPaginations[tableName].current_page"
            :page-size="dataPaginations[tableName].per_page" :total="dataPaginations[tableName].total"
            @current-change="pageChange">
          </el-pagination>
        </div>
      </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { debounce, forEach, findIndex } from 'lodash'
import ls from 'local-storage'

export default {
  name: 'gs-table',
  props: {
    tableName: {
      type: String,
      default: 'anonymous'
    },
    dataSource: {
      type: String,
      default: null
    },
    dataParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    dataSorted: {
      type: Object,
      default: () => {
        return {
          created_at: -1
        }
      }
    },
    dataSorts: {
      type: Array,
      default: () => {
        return [
          { key: 'created_at', name: 'Ngày tạo' }
        ]
      }
    },
    searchText: {
      type: String,
      default: 'Tìm kiếm'
    },
    cacheData: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      q: null,
      sortStatus: ''
    }
  },
  computed: {
    ...mapGetters('gsTable', ['dataTable', 'dataTables', 'dataPaginations', 'tableQueries'])
  },
  methods: {
    ...mapActions('gsTable', ['fetchTableData', 'setTableData', 'setPaginator', 'setTableQuery']),
    fetchData() {
      this.sort()
      this.dataParams.q = this.tableQueries[this.tableName] ? this.tableQueries[this.tableName] : null
      if (typeof this.dataPaginations[this.tableName] !== 'undefined') {
        this.dataParams.page = this.dataPaginations[this.tableName].current_page
      }

      this.fetchTableData({
        url: this.dataSource,
        params: this.dataParams,
        table_name: this.tableName
      })
    },
    filter: debounce(function () {
      if (this.q !== this.tableQueries[this.tableName]) {
        this.setTableQuery({ table_name: this.tableName, value: this.q })
        this.fetchData()
      }
    }, 500),
    sort() {
      let sort = ''
      forEach(this.dataSorted, (value, key) => {
        if (value) {
          sort += `${key}:${value},`
        }
      })
      this.dataParams.sort = sort.slice(0, sort.length - 1)
      let lsSorteds = ls.get('sorteds', {})
      if (!lsSorteds) {
        lsSorteds = {}
      }
      lsSorteds[this.tableName] = this.dataSorted
      ls.set('sorteds', lsSorteds)
    },
    removeFilter() {
      this.setTableQuery({ table_name: this.tableName, value: null })
      this.q = null
      this.$emit('remove-filter')
    },
    pageChange(page) {
      this.setPaginator({ table_name: this.tableName, key: 'current_page', value: page })
      if (this.dataParams.page !== page) {
        this.fetchData()
      }
    }
  },
  mounted() {
    if (this.cacheData) {
      if (typeof this.dataTables[this.tableName] === 'undefined') {
        this.fetchData()
      } else {
        this.setTableData(this.tableName)
        this.q = this.tableQueries[this.tableName] ? this.tableQueries[this.tableName] : null
      }
    } else {
      this.fetchData()
    }
  },
  created() {
    this.$on('reload-table', () => {
      if (typeof this.dataPaginations[this.tableName] !== 'undefined') {
        this.setPaginator({ table_name: this.tableName, key: 'current_page', value: 1 })
      }
      if (typeof this.dataTables[this.tableName] !== 'undefined') {
        this.fetchData()
      }
    })
  },
  watch: {
    dataSorted: {
      handler: function (value) {
        let sortTxt = ''
        forEach(this.dataSorted, (value, key) => {
          if (value) {
            if (findIndex(this.dataSorts, { key: key }) > -1) {
              sortTxt += this.dataSorts[findIndex(this.dataSorts, { key: key })]['name'] + `: ${value === 1 ? 'tăng' : 'giảm'}, `
            } else {
              sortTxt += `${key}: ${value === 1 ? 'tăng' : 'giảm'}, `
            }
          }
        })
        this.sortStatus = sortTxt.slice(0, sortTxt.length - 2)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// GsTable.vue?1b59d396